import React from 'react';
import { Box } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

import { AdminLegendVariant } from '@pharmaplan/common';
import styles from './styles';
import legendStyles from '../AdminLegend/styles';
import AdminSplitLegendItem, { IAdminSplitLegendItem } from './AdminSplitLegendItem/AdminSplitLegendItem';

export type AdminSplitLegendEntry = Omit<IAdminSplitLegendItem, 'variant' | 'isRow'>;

interface IAdminSplitLegend {
  variant: `${AdminLegendVariant}`;
  items: Array<AdminSplitLegendEntry>;
  isRow: boolean;
  customClass?: Record<string, unknown>;
}

const AdminSplitLegend = ({
  variant,
  items,
  isRow,
  customClass,
}: IAdminSplitLegend) =>
  (
    <Box
      sx={[
        legendStyles.legendContainerBg(variant),
        styles.container,
        isRow && styles.rowContainer,
        customClass as SystemStyleObject,
      ]}
    >
      <Box sx={[styles.itemsContainer, styles.separatorColor(variant)]}>
        {items.map((item) =>
          (
            <AdminSplitLegendItem
              key={item.labelKey}
              labelKey={item.labelKey}
              variant={variant}
              replacementType={item.replacementType}
              totalHrs={item.totalHrs}
              totalCount={item.totalCount}
              isRow={isRow}
            />
          ))}
      </Box>
    </Box>
  );

export default AdminSplitLegend;
